export default "__VITE_ASSET__CdSFRQfR__"